/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkOrderSiteQueryAttachmentDto } from './workOrderSiteQueryAttachmentDto';
import { WorkOrderSiteQueryReferenceDto } from './workOrderSiteQueryReferenceDto';

export interface WorkOrderSiteQueryDto {
  id?: string;
  workOrderId?: string;
  workOrderNumber?: string;
  documentType?: string;
  sqNumber?: string;
  revision?: string;
  taskId?: string;
  title?: string;
  deliveryId?: string;
  site?: string;
  discipline?: string;
  reason?: WorkOrderSiteQueryDto.ReasonEnum;
  caseType?: WorkOrderSiteQueryDto.CaseTypeEnum;
  quantityChange?: boolean;
  scheduleImpact?: boolean;
  materialNeed?: boolean;
  description?: string;
  suggestedSolution?: string;
  references?: string;
  selectedReferences?: Array<WorkOrderSiteQueryReferenceDto>;
  initiatedBy?: string;
  company?: string;
  queryDate?: string;
  siteLeader?: string;
  integrationManager?: string;
  status?: WorkOrderSiteQueryDto.StatusEnum;
  createdAt?: string;
  attachments?: Array<WorkOrderSiteQueryAttachmentDto>;
}
export namespace WorkOrderSiteQueryDto {
  export const ReasonEnum = {
    Clarify: 'CLARIFY',
    Quantity: 'QUANTITY',
  } as const;
  export type ReasonEnum = (typeof ReasonEnum)[keyof typeof ReasonEnum];
  export const CaseTypeEnum = {
    ToleranceDeviation: 'TOLERANCE_DEVIATION',
    OffshoreChange: 'OFFSHORE_CHANGE',
    MaterialRepair: 'MATERIAL_REPAIR',
    OtherClarification: 'OTHER_CLARIFICATION',
  } as const;
  export type CaseTypeEnum = (typeof CaseTypeEnum)[keyof typeof CaseTypeEnum];
  export const StatusEnum = {
    Draft: 'DRAFT',
  } as const;
  export type StatusEnum = (typeof StatusEnum)[keyof typeof StatusEnum];
}
